import { useTranslations } from 'next-intl'
import React from 'react'

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

import DashboardLoadingIcon from '../icon/dashboard-loading-icon'
import { Button } from '../ui/button'

interface AlertModalProps {
  title?: string
  description?: string
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  isLoading?: boolean
  isShowDescription?: boolean
  titleButtonSubmit?: string
}

export const AlertModal: React.FC<AlertModalProps> = ({
  isOpen,
  isLoading,
  onClose,
  onConfirm,
  title,
  description,
  isShowDescription = true,
  titleButtonSubmit,
}) => {
  const t = useTranslations('Common.Components')

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent
        className="w-[320px] sm:w-[400px] md:w-[450px] lg:w-[500px]"
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>{title || t('modal.alertModal.title')}</DialogTitle>
          <DialogDescription>
            {isShowDescription ? description || t('modal.alertModal.description') : ''}
          </DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <div className="flex w-full justify-end gap-4">
            <Button disabled={isLoading} variant="outline" onClick={onClose}>
              {t('modal.common.cancel')}
            </Button>
            <Button disabled={isLoading} variant="default" onClick={onConfirm}>
              {titleButtonSubmit || t('modal.common.confirm')}
              {isLoading && <DashboardLoadingIcon className="ml-2 text-base-muted" />}
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
